import { Location } from '@angular/common';
import { Component, inject } from '@angular/core';
import { KENDO_BUTTON } from '@progress/kendo-angular-buttons';
import { KENDO_CARD, KENDO_LAYOUT } from '@progress/kendo-angular-layout';
import { PageContainerComponent } from '@unity/layouts/page-container/page-container.component';

@Component({
  selector: 'unity-not-found-page',
  standalone: true,
  imports: [KENDO_LAYOUT, KENDO_CARD, KENDO_BUTTON, PageContainerComponent],
  templateUrl: './not-found-page.component.html',
  styleUrl: './not-found-page.component.scss',
})
export class NotFoundPageComponent extends Component {
  private readonly location = inject(Location);

  protected contentHeader = '404: Page Not Found';

  protected return() {
    this.location.back();
  }
}
